enum Sections {
  AboutThePrice = 'about-the-price',
  AncillaryProducts = 'ancillary-products',
  Breadcrumbs = 'breadcrumbs',
  Disclaimer = 'disclaimer',
  Gallery = 'gallery',
  General = 'navigation-section',
  Hero = 'hero',
  Inspection = 'inspection',
  FeaturesAndHighlights = 'features-and-highlights',
  MoneyBackGuarantee = 'money-back-guarantee',
  OwnerReviews = 'owner-reviews',
  PickupAndDelivery = 'pickup-and-delivery',
  PriceDetails = 'price-details',
  RecommendedVehicles = 'recommended-vehicles',
  Root = 'root',
  Spinner = 'spinner-container',
  VehicleDetails = 'vehicle-details'
}

export default Sections;
